module.exports = __webpack_public_path__ + "img/biletbank.45fad90f.png";